import React from "react";
import { IoIosArrowForward } from "react-icons/io";
const ArrowAnimation = () => {
  return <div className="inline-flex justify-center items-baseline mr-3 text-[#bdff57] font-extrabold text-2xl">
            <div className="flex -space-x-1 animate-oscillate items-center">
                {[...Array(3)].map((_, i) => <IoIosArrowForward key={i} className="relative top-0.5" />)}
            </div>
        </div>;
};
export default ArrowAnimation;